module.exports = __webpack_public_path__ + "img/copPerDegree.e36becb2.png";